import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectTripInterruptionStep = (state) => state.get('tripInterruptionStep');

const makeSelectTripInterruptionStep = () => createSelector(
  selectTripInterruptionStep,
  (selectTripInterruptionSate) => ({

    schoolNameForInterruption: mapWithDefault(
      selectTripInterruptionSate,
      () => selectTripInterruptionSate.getIn(['form', 'schoolNameForInterruption']),
      ''
    ),

    areYouInterruptingTheTripDueToMedicalReasons: mapWithDefault(
      selectTripInterruptionSate,
      () => selectTripInterruptionSate.getIn(['form', 'areYouInterruptingTheTripDueToMedicalReasons']),
      ''
    ),

    // Trip Interruption
    travelInterruption: mapWithDefault(
      selectTripInterruptionSate,
      () => selectTripInterruptionSate.getIn(['form', 'travelInterruption']),
      ''
    ),

    reasonsForTripInterruption: mapWithDefault(
      selectTripInterruptionSate,
      () => selectTripInterruptionSate.getIn(['form', 'reasonsForTripInterruption']),
      ''
    ),

    companyNameTravelInterruption: mapWithDefault(
      selectTripInterruptionSate,
      () => selectTripInterruptionSate.getIn(['form', 'companyNameTravelInterruption']),
      ''
    ),

    addressTravelInterruption: mapWithDefault(
      selectTripInterruptionSate,
      () => selectTripInterruptionSate.getIn(['form', 'addressTravelInterruption']),
      ''
    ),

    cityTravelInterruption: mapWithDefault(
      selectTripInterruptionSate,
      () => selectTripInterruptionSate.getIn(['form', 'cityTravelInterruption']),
      ''
    ),

    stateTravelInterruption: mapWithDefault(
      selectTripInterruptionSate,
      () => selectTripInterruptionSate.getIn(['form', 'stateTravelInterruption']),
      ''
    ),
    zipCodeTravelInterruption: mapWithDefault(
      selectTripInterruptionSate,
      () => selectTripInterruptionSate.getIn(['form', 'zipCodeTravelInterruption']),
      ''
    ),

    contactTravelInterruption: mapWithDefault(
      selectTripInterruptionSate,
      () => selectTripInterruptionSate.getIn(['form', 'contactTravelInterruption']),
      ''
    ),

    phoneNumberTravelInterruption: mapWithDefault(
      selectTripInterruptionSate,
      () => selectTripInterruptionSate.getIn(['form', 'phoneNumberTravelInterruption']),
      ''
    ),

    includedInPackage: mapWithDefault(
      selectTripInterruptionSate,
      () => selectTripInterruptionSate.getIn(['form', 'includedInPackage']),
      ''
    ),

    dateTripInterrupted: mapWithDefault(
      selectTripInterruptionSate,
      () => selectTripInterruptionSate.getIn(['form', 'dateTripInterrupted']),
      ''
    ),

    reasonForInterruption: mapWithDefault(
      selectTripInterruptionSate,
      () => selectTripInterruptionSate.getIn(['form', 'reasonForInterruption']),
      ''
    ),

    nameOfPersonHavingSickness: mapWithDefault(
      selectTripInterruptionSate,
      () => selectTripInterruptionSate.getIn(['form', 'nameOfPersonHavingSickness']),
      ''
    ),

    dateOfBirth: mapWithDefault(
      selectTripInterruptionSate,
      () => selectTripInterruptionSate.getIn(['form', 'dateOfBirth']),
      ''
    ),

    relationshipToClaimant: mapWithDefault(
      selectTripInterruptionSate,
      () => selectTripInterruptionSate.getIn(['form', 'relationshipToClaimant']),
      ''
    ),

    dateSicknessOrInjuryBegan: mapWithDefault(
      selectTripInterruptionSate,
      () => selectTripInterruptionSate.getIn(['form', 'dateSicknessOrInjuryBegan']),
      ''
    ),

    dateEnded: mapWithDefault(
      selectTripInterruptionSate,
      () => selectTripInterruptionSate.getIn(['form', 'dateEnded']),
      ''
    ),

    natureOfSicknessOrInjury: mapWithDefault(
      selectTripInterruptionSate,
      () => selectTripInterruptionSate.getIn(['form', 'natureOfSicknessOrInjury']),
      ''
    ),

    periodOfHospitalization: mapWithDefault(
      selectTripInterruptionSate,
      () => selectTripInterruptionSate.getIn(['form', 'periodOfHospitalization']),
      ''
    ),

    fromDate: mapWithDefault(
      selectTripInterruptionSate,
      () => selectTripInterruptionSate.getIn(['form', 'fromDate']),
      ''
    ),

    toDate: mapWithDefault(
      selectTripInterruptionSate,
      () => selectTripInterruptionSate.getIn(['form', 'toDate']),
      ''
    ),

    dateOfInitialPaymentDeposit: mapWithDefault(
      selectTripInterruptionSate,
      () => selectTripInterruptionSate.getIn(['form', 'dateOfInitialPaymentDeposit']),
      ''
    ),

    companyNameLoss: mapWithDefault(selectTripInterruptionSate, () => selectTripInterruptionSate.getIn(['form', 'companyNameLoss']), ''),
    amountPaidLoss: mapWithDefault(selectTripInterruptionSate, () => selectTripInterruptionSate.getIn(['form', 'amountPaidLoss']), ''),
    currentAmountPaidLoss: mapWithDefault(selectTripInterruptionSate, () => selectTripInterruptionSate.getIn(['form', 'currentAmountPaidLoss']), ''),
    amountOfLoss: mapWithDefault(selectTripInterruptionSate, () => selectTripInterruptionSate.getIn(['form', 'amountOfLoss']), ''),
    currentAmountOfLoss: mapWithDefault(selectTripInterruptionSate, () => selectTripInterruptionSate.getIn(['form', 'currentAmountOfLoss']), ''),
    haveYouReceivedReimbursement: mapWithDefault(selectTripInterruptionSate, () => selectTripInterruptionSate.getIn(['form', 'haveYouReceivedReimbursement']), ''),
    howMuchReceivedReimbursement: mapWithDefault(selectTripInterruptionSate, () => selectTripInterruptionSate.getIn(['form', 'howMuchReceivedReimbursement']), ''),
    currentReceivedReimbursement: mapWithDefault(selectTripInterruptionSate, () => selectTripInterruptionSate.getIn(['form', 'currentReceivedReimbursement']), ''),
    fromWhomReceivedReimbursement: mapWithDefault(selectTripInterruptionSate, () => selectTripInterruptionSate.getIn(['form', 'fromWhomReceivedReimbursement']), ''),
    dateReimbursementReceived: mapWithDefault(selectTripInterruptionSate, () => selectTripInterruptionSate.getIn(['form', 'dateReimbursementReceived']), ''),
    lossInformationItems: mapWithDefault(selectTripInterruptionSate, () => selectTripInterruptionSate.getIn(['form', 'lossInformationItems']) && selectTripInterruptionSate.getIn(['form', 'lossInformationItems']).toJS(), ''),
    insureds: mapWithDefault(selectTripInterruptionSate, () => selectTripInterruptionSate.getIn(['form', 'insureds']) && selectTripInterruptionSate.getIn(['form', 'insureds']).toJS(), ''),
    enableTime: mapWithDefault(selectTripInterruptionSate, () => selectTripInterruptionSate.getIn(['form', 'enableTime']), null),
  })
);

const makeSelectTripInterruptionStepErrors = () =>
  createSelector(selectTripInterruptionStep, (state) => state.get('errors'));

export {
  makeSelectTripInterruptionStep,
  makeSelectTripInterruptionStepErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.TripInterruptionStep/selectors.js